
/* eslint-disable max-len */

import { Injectable } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { Solution } from '../../models/service/solution';
import { SolutionDetails } from '../../models/service/solution-details';
import { FabricService } from 'src/app/services/fabric/fabric.service';
import { LineOfBusiness } from 'src/app/models/line-of-business';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { ServiceCardService } from '../util/service-card.service';
import { Subject } from 'rxjs';

const SERVICE_NAME = 'solution-resources';
const SERVICE_NAME_LOB = 'lob-resources';

@Injectable({
  providedIn: 'root'
})
export class SolutionsService {

  mockedTutorialsData = [
    {
      title: 'Video One',
    },
    {
      title: 'Video Two',
    },
    {
      title: 'Video Three',
    },
    {
      title: 'Video Four',
    },
    {
      title: 'Video Five',
    },
    {
      title: 'Video Six',
    },
  ];

  mockedDocumentationData = [
    {
      title: 'Quick help on Configuration',
      description: 'Retail Banking - Lending helps Client banks of any size and business segment (Retail, Corporate, Business, Wealth and Universal).',
      link: 'https://www.temenos.com'
    },
    {
      title: 'How to guide',
      description: 'Retail Banking - Lending helps Client banks of any size and business segment (Retail, Corporate, Business, Wealth and Universal).',
      link: 'https://www.temenos.com'
    },
    {
      title: 'Installation of Packages',
      description: 'Retail Banking - Lending helps Client banks of any size and business segment (Retail, Corporate, Business, Wealth and Universal).',
      link: 'https://www.temenos.com'
    }
  ];

  constructor(private blueprintsService: BlueprintsService, private fabricService: FabricService, private serviceCard: ServiceCardService) {

  }

  getSolutions(): Observable<Solution[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_solutions');
  }

  getMySolutions(page?: string): Observable<Solution[]> {
    return combineLatest([this.getSolutions(), this.blueprintsService.getBlueprints()])
    .pipe(map(([solutions, blueprints]) => {
      const blueprintsList = page !== 'myServices' ? this.serviceCard.latestBluePrints(blueprints) : blueprints;
      const solutionsWithBlueprints = blueprintsList
      .reduce((acc, blueprint) => {
        acc.add(blueprint.solutionId);
        return acc;
      }, new Set());

      const latestSolution = solutions.filter((solution) => solutionsWithBlueprints.has(solution.id));
      return latestSolution;
    }));
  }


  getSolutionDetailsById(id: string): Observable<SolutionDetails> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_solutions_id', {id})
      .pipe(tap((solutionDetails) => {
        if (solutionDetails) {
          solutionDetails.tutorials = this.mockedTutorialsData;
          solutionDetails.documentation = this.mockedDocumentationData;
          return of(solutionDetails);
        }
      }));
  }

  getLineOfBusinesses(): Observable<LineOfBusiness[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME_LOB, 'get_line-of-business');
  }

  getSolutionVersions(solutionId: string): Observable<SolutionVersion[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_solutions_solutionid_versions', {solutionId});
  }

  getSolutionVersion(solutionId: string, solutionVersionId: string): Observable<SolutionVersion> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_solutions_solutionid_versions_id', {solutionId, id: solutionVersionId});
  }

}
